"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const CloseRounded_1 = __importDefault(require("@material-ui/icons/CloseRounded"));
/**
 * A Dialog with a configurable title, content, and two action buttons.
 *
 * Please feel free to add additional features - reach out to [#mosaic](slack://channel?team=T02835DET&id=CE299KC1X) for any help or guidance.
 */
const BasicDialog = ({ title, content, open, onCancel, onConfirm, confirmDisabled = false, confirmLabel = 'Confirm', cancelLabel = 'Cancel', showCloseIcon = false, showCancelButton = false, dialogProps, }) => {
    const onIconClick = react_1.useCallback((e) => onCancel(e, 'closeIconClick'), [onCancel]);
    const onCancelClick = react_1.useCallback((e) => onCancel(e, 'cancelButtonClick'), [onCancel]);
    // Wrap `content` or `title` in Typography if they are string/number/null
    const Title = react_1.default.isValidElement(title) ? title : react_1.default.createElement(core_1.Typography, { variant: "h3" }, title);
    const Content = react_1.default.isValidElement(content) ? (content) : (react_1.default.createElement(core_1.Typography, { variant: "body1" }, content));
    return (react_1.default.createElement(core_1.Dialog, Object.assign({ open: open, onClose: onCancel, "aria-labelledby": "BasicDialog-title", "aria-describedby": "BasicDialog-content" }, dialogProps),
        react_1.default.createElement(core_1.Grid, { container: true, justify: "space-between" },
            react_1.default.createElement(core_1.DialogTitle, { id: "BasicDialog-title", disableTypography: true }, Title),
            showCloseIcon && (react_1.default.createElement(core_1.IconButton, { className: "pa-6", "aria-label": "close", onClick: onIconClick },
                react_1.default.createElement(CloseRounded_1.default, null)))),
        react_1.default.createElement(core_1.DialogContent, { id: "BasicDialog-content" }, Content),
        react_1.default.createElement(core_1.DialogActions, null,
            showCancelButton && (react_1.default.createElement(core_1.Button, { variant: "text", color: "primary", onClick: onCancelClick }, cancelLabel)),
            onConfirm && (react_1.default.createElement(core_1.Button, { color: "primary", disabled: confirmDisabled, onClick: onConfirm }, confirmLabel)))));
};
exports.default = BasicDialog;
